import React, { useContext, useState } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
import { useTheme } from '@emotion/react';
// Mui components
import { Button, Modal, Typography, Backdrop, Fade, Box } from '@mui/material';
// Components
import DotLoader from '../../common/Loaders/DotLoader/DotLoader.jsx';
import CustomSnackbar from '../../common/CustomSnackbar.jsx';
// ErrorProvider
import { useError } from '../../../contexts/ErrorProvider.jsx';

export default function ModalConfirmarAnularSolicitud({ modalIsVisible, solicitud, handleClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const theme = useTheme();
  const { anularSolicitud, getConsultoriosWithContrato, contratoSeleccionado } = useContext(AgendaContext);
  const { handleError } = useError();
  const { id, direccionOsde } = solicitud;
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const handleConfirmar = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await anularSolicitud(id, 'ANULADO');

      setSnackbarMessage('Solicitud anulada correctamente.');
      setSnackbarSeverity('info');
      setSnackbarOpen(true);
      handleClose();
      getConsultoriosWithContrato(contratoSeleccionado);

    } catch (error) {
      setSnackbarMessage('Error al anular la solicitud.');
      setSnackbarSeverity('error'); // ❌ Rojo
      setSnackbarOpen(true);
      handleError({ error: error, description: 'initializeError' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalIsVisible}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}>
        <Fade in={modalIsVisible}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: 452, sm: 452 },
              height: '284px',
              bgcolor: 'white.main',
              borderRadius: '16px',
              p: 5
            }}>
            <Typography
              id="detalles"
              variant="h2"
              sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              ¿Querés anular esta solicitud?
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: '1rem'
              }}>
              <Typography variant="bodyM">
                No se analizará la solicitud sobre el consultorio ubicado en{' '}
                <Typography variant="boldBodyM">{direccionOsde}</Typography>
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                marginTop: '28px',
                justifyContent: 'space-around'
              }}>
              <Button
                variant="outlined"
                disabled={isLoading}
                onClick={handleClose}
                sx={{
                  width: '176px',
                  height: '3rem',
                  borderRadius: '1rem',
                  '&.Mui-disabled': {
                    borderColor: theme.palette.gray.main
                  }
                }}>
                Mejor no
              </Button>

              <Box sx={{ position: 'relative' }}>
                <Button
                  sx={{
                    width: '176px',
                    height: '3rem',
                    borderRadius: '1rem',
                    '&.Mui-disabled': {
                      backgroundColor: isLoading
                        ? theme.palette.darkBlue.main
                        : theme.palette.primary.main
                    }
                  }}
                  disabled={isLoading}
                  variant="contained"
                  onClick={handleConfirmar}
                  color="primary">
                  Sí, anular
                  {isLoading && (
                    <Box sx={{ position: 'absolute', right: '6px' }}>
                      <DotLoader />
                    </Box>
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
}
